import SEO from "../../data/seo";
import FooterTwo from "../../layout/footers/footer-two";
import HeaderTwo from "../../layout/headers/header-two";
import BreadCrumb from "../common/breadcrumb";
import ContactMain from "./contact";

const ContactUs = () => {
    return (
        <>
            <SEO pageTitle="Contact Us" />
            <HeaderTwo />
            <BreadCrumb title="Contact Us" innerTitle="Contact Us" />
            <ContactMain />
            <div className="map section-padding pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay=".4s">
                            <div className="map-area">
                                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.15830894606!2d-74.11976383964463!3d23.772735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sDhaka!5e0!3m2!1sen!2sbd!4v1652012644726!5m2!1sen!2sbd" loading="lazy" title="Dhaka" aria-label="London Eye, London, United Kingdom"></iframe> */}
                                <iframe
  src="https://www.google.com/maps?q=23.772735,90.407988&z=15&output=embed"
  loading="lazy"
  title="Dhaka"
  aria-label="Dhaka, Bangladesh"
></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterTwo />
        </>
    );
    // 23.772735, 90.407988
};

export default ContactUs;